import React from "react";
import styled from "styled-components";
import BannerImg from "../images/Sleep-Explainer.jpg";
import BTCIMG from "../images/BTC.png";
import QueensImg from "../images/Queens.png";
import USCImg from "../images/USC.png";
import WhoCan from "../images/who_can.png";
import WhyParticipate from "../lottie/why_participate.json";
import WhatExpect from "../lottie/what.json";
import ClickJson from "../lottie/click.json";
import Lottie from "lottie-react";
import { device } from "../responsive";

export const Home = () => {
  const WhyLottie = () => (
    <WhyLottieDiv>
      <Lottie animationData={WhyParticipate} loop={true} />
    </WhyLottieDiv>
  );
  const WhatLottie = () => (
    <WhatLottieDiv>
      <Lottie animationData={WhatExpect} loop={true} />
    </WhatLottieDiv>
  );
  const ClickLottie = () => (
    <ClickLottieDiv>
      <Lottie animationData={ClickJson} loop={true} />
    </ClickLottieDiv>
  );
  return (
    <Container>
      <LogoDiv>
        <LogoIMG src={BTCIMG} alt="BTC logo" />
        <LogoIMG src={QueensImg} alt="Queens logo" />
        <LogoIMG src={USCImg} alt="USC logo" />
      </LogoDiv>
      <Banner>
        <BannerImage src={BannerImg} alt="Banner" />
        <BannerTextDiv>
          <Title>
            Exploring a new intervention approach for children with ASD and
            sleep disorders
          </Title>
          <Subtitle>A Clinical Pilot Trial</Subtitle>
        </BannerTextDiv>
      </Banner>

      <Body>
        <TopParagraphDiv>
          <TopParagraph>
            If your child has been diagnosed with autism spectrum disorder (ASD)
            and sleep disorder or reported sleep difficulties such as sleep
            anxiety, bedtime resistance, sleep-onset delays, shorter sleep
            duration, frequent and prolonged night waking, parasomnia, insomnia,
            low sleep efficiency, early waking, and/or daytime sleepiness,
            please fill the{" "}
            <a
              style={{
                color: "black",
                fontWeight: "bold",
                textDecoration: "none"
              }}
              href="#EOI"
            >
              Expression Of Interest
            </a>{" "}
            form below to discuss possible participation in a research study
            using an individualised, non-pharmacological and non-invasive
            treatment option for improving ASD core deficits and sleep
            difficulties.
            <br />
            This research study has ethics approval number S221766 and is
            registered under the Australian New Zealand Clinical Trials Registry
            (ANZCTR): ACTRN12623000757617
          </TopParagraph>
        </TopParagraphDiv>
        <WhyParticipateDiv>
          <WhyLottie />
          <WhyTextDiv>
            <h2>Why Participate ?</h2>
            <ul>
              <li>Your child may experience improved sleep</li>
              <li>
                Your child may experience improved social, communication, and
                behavioural skills.{" "}
              </li>
              <li>Your child may experience an improved quality of life. </li>
              <li>
                You may experience an improved quality of life and wellbeing as
                a primary caregiver.{" "}
              </li>
            </ul>
          </WhyTextDiv>
        </WhyParticipateDiv>
        <WhoCanParticipateDiv>
          <WhoCanParticipateHeader>
            <h2>Who can participate? </h2>
            <img src={WhoCan} alt="Who-can-participateimage" />
          </WhoCanParticipateHeader>
          <WhoCanParticipateTextDiv>
            <ul>
              <li>
                Children between 6-12 years old with a diagnosis of ASD (level
                2) and with sleep difficulties and who can undergo 2 to 4 sleep
                assessments using polysomnography (at-home sleep monitor) and
                actigraphy (wearable on the wrist);
              </li>
              <li>
                Who have never been treated with repetitive transcranial
                magnetic stimulation (rTMS) or EEG tailored transcranial
                magnetic stimulation (α-rTMS) before
              </li>
            </ul>
          </WhoCanParticipateTextDiv>
        </WhoCanParticipateDiv>
        <WhatDiv>
          <WhatTextDiv>
            <h2>What can I expect? </h2>
            <ol>
              <li>
                You and your child must be able and willing to attend at least
                ten α-rTMS sessions (one per weekday for two consecutive weeks),
                including two electroencephalograms (EEGs) and at least two
                clinical consultations at the Brain Treatment Centre, Australia,
                located at 19-31 Dickson Road, Morayfield.{" "}
              </li>
              <li>
                You will be asked questions about your child’s medical history,
                current symptoms, and sleep patterns and how this affects your
                quality of life as a primary caregiver.
              </li>
              <li>
                We will show you how the at-home actigraphy and polysomnography
                work and be available to answer any questions you may have
                (after-service hours include).
              </li>
              <li>
                Participants on the National Disability Insurance Scheme (NDIS)
                who have never been treated with rTMS or α-rTMS are also
                welcomed to be part of this study.
              </li>
            </ol>
          </WhatTextDiv>
          <WhatLottie />
        </WhatDiv>
        <EOI id="EOI">
          <ClickLottie />
          <EOIButton>
            <a
              target="_blank"
              href="https://forms.office.com/r/LqbSnBLLsi"
              rel="noreferrer"
            >
              Expression Of Interest
            </a>
          </EOIButton>
        </EOI>
      </Body>
    </Container>
  );
};

const Container = styled.div`
  font-family: "Poppins", sans-serif;
  box-sizing: border-box;
  padding: 2rem 1rem;
  @media ${device.mobileL} {
    padding: 1rem 0;
  }
`;

const Banner = styled.div`
  width: 100%;
  height: 28rem;
  position: relative;
  display: flex;
  align-items: center;
  @media ${device.mobileL} {
    height: 15rem;
  }
`;
const BannerImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 28rem;
  object-fit: cover;
  opacity: 0.8;
  @media ${device.mobileL} {
    height: 15rem;
  }
`;
const BannerTextDiv = styled.div`
  position: relative;
  box-sizing: border-box;
  padding: 2rem;
  color: white;
  @media ${device.mobileL} {
    padding: 0.5rem 1rem;
  }
`;
const Title = styled.h1`
  width: 70%;
  text-align: left;
  font-size: 50px;
  @media ${device.mobileL} {
    width: 95%;
    font-size: 25px;
  }
`;

const Subtitle = styled.h3`
  text-align: left;
  font-size: 20px;
  @media ${device.mobileL} {
    font-size: 14px;
  }
`;
const LogoDiv = styled.div`
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${device.mobileL} {
    margin-bottom: 1rem;
    padding: 0 0.5rem;
  }
`;

const LogoIMG = styled.img`
  width: 14rem;
  height: 3rem;
  @media ${device.mobileL} {
    width: 5rem;
    height: 2rem;
  }
`;

const Body = styled.div`
  box-sizing: border-box;
`;
const TopParagraphDiv = styled.div`
  margin-top: 2rem;
  box-sizing: border-box;
  padding: 2rem;
  @media ${device.mobileL} {
    margin-top: 1rem;
    padding: 1rem;
  }
`;
const TopParagraph = styled.p`
  text-align: left;
  font-size: 1.2rem;
  width: 90%;
  line-height: 2.2rem;
  font-weight: 400;
  @media ${device.mobileL} {
    font-size: 1rem;
    width: 95%;
    line-height: 1.5rem;
  }
`;

const WhyParticipateDiv = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: 2rem;
  justify-content: space-between;
  align-items: center;
  background-color: black;
  border-radius: 10px;
  @media ${device.mobileL} {
    margin: 0 0.5rem;
    flex-direction: column;
    padding: 1rem;
  }
`;
const WhyLottieDiv = styled.div`
  width: 30%;
  max-height: 45rem;
`;
const WhyTextDiv = styled.div`
  width: 50%;
  color: white;
  @media ${device.mobileL} {
    width: 98%;
  }
  h2 {
    text-align: center;
    font-size: 2rem;
    margin: 1rem 0;
    @media ${device.mobileL} {
      font-size: 1.6rem;
    }
  }
  ul {
    text-align: left;
  }
  li {
    font-size: 1rem;
    margin-bottom: 1rem;
  }
`;

const WhoCanParticipateDiv = styled.div`
  margin: 4rem 0;
  padding: 0 2rem;
  box-sizing: border-box;
  @media ${device.mobileL} {
    padding: 0 0.5rem;
  }
`;
const WhoCanParticipateHeader = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: fit-content;

  img {
    width: 6rem;
    height: 6rem;
    object-fit: contain;
    @media ${device.mobileL} {
      width: 4rem;
      height: 4rem;
    }
  }

  h2 {
    font-size: 2rem;
    @media ${device.mobileL} {
      font-size: 1.6rem;
    }
  }
`;
const WhoCanParticipateTextDiv = styled.div`
  ul {
    text-align: left;
  }
  li {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    line-height: 2rem;
    width: 90%;
    @media ${device.mobileL} {
      width: 95%;
      line-height: 1.5rem;
      font-size: 1rem;
    }
  }
`;

const WhatDiv = styled.div`
  background-color: #cdd5fd;
  padding: 2rem;
  box-sizing: border-box;
  border-radius: 10px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${device.mobileL} {
    padding: 1rem;
    flex-direction: column-reverse;
    margin: 0.5rem;
  }
`;
const WhatTextDiv = styled.div`
  color: black;
  width: 75%;
  @media ${device.mobileL} {
    width: 98%;
  }
  h2 {
    text-align: left;
    font-size: 2rem;
    margin: 1rem 0;
    margin-left: 2rem;
    @media ${device.mobileL} {
      font-size: 1.6rem;
    }
  }
  ol {
    text-align: left;
  }
  li {
    font-size: 1rem;
    margin-bottom: 1rem;
    font-weight: 600;
    line-height: 2rem;
    @media ${device.mobileL} {
      line-height: 1.5rem;
      font-size: 0.8rem;
    }
  }
`;
const WhatLottieDiv = styled.div`
  width: 20%;
  max-height: 45rem;
  @media ${device.mobileL} {
    width: 40%;
  }
`;

const EOI = styled.div`
  margin: 5rem auto;
  width: fit-content;
  position: relative;
`;
const EOIButton = styled.div`
  position: relative;
  transition: all 0.1s ease-in-out;
  background-color: transparent;
  z-index: 10;
  :hover {
    color: white;
    background-color: #20a0d8;
  }
  a {
    font-size: 1.8rem;
    font-weight: bold;
    text-decoration: none;
    color: black;
    padding: 0.5rem 1rem;
    border-radius: 10px;
    :hover {
      color: white;
    }
  }
`;

const ClickLottieDiv = styled.div`
  position: absolute;
  width: 10rem;
  height: 5rem;
  top: -2.2rem;
  right: 4rem;
`;
